export interface RoutePermission {
  pattern: string
  permission: string
}

export const routePermissions: RoutePermission[] = [
  {
    pattern: '/lead-flows',
    permission: 'lop:ui:path:read:/lead-flows',
  },
  {
    pattern: '/lead-flows/new/*',
    permission: 'lop:ui:path:read:/lead-flows/new',
  },
  {
    pattern: '/lead-flows/:slug/edit/*',
    permission: 'lop:ui:path:read:/lead-flows/:slug/edit',
  },
  {
    pattern: '/tests',
    permission: 'lop:ui:path:read:/tests',
  },
  {
    pattern: '/tests/new/*',
    permission: 'lop:ui:path:read:/tests/new',
  },
  {
    pattern: '/tests/:id/edit/*',
    permission: 'lop:ui:path:read:/tests/:id/edit',
  },
  {
    pattern: '/pixels',
    permission: 'lop:ui:path:read:/pixels',
  },
  {
    pattern: '/pixels/new/*',
    permission: 'lop:ui:path:read:/pixels/new',
  },
  {
    pattern: '/pixels/:id/edit/*',
    permission: 'lop:ui:path:read:/pixels/:id/edit',
  },
  {
    pattern: '/partners',
    permission: 'lop:ui:path:read:/partners',
  },
  {
    pattern: '/partners/new',
    permission: 'lop:ui:path:read:/partners/new',
  },
  {
    pattern: '/partners/:id/edit',
    permission: 'lop:ui:path:read:/partners/:id/edit',
  },
  {
    pattern: '/users',
    permission: 'lop:ui:path:read:/users',
  },
  {
    pattern: '/users/new',
    permission: 'lop:ui:path:read:/users/new',
  },
  {
    pattern: '/users/:id/edit',
    permission: 'lop:ui:path:read:/users/:id/edit',
  },
  {
    pattern: '/admin/roles',
    permission: 'lop:ui:path:read:/admin/roles',
  },
  {
    pattern: '/admin/roles/new',
    permission: 'lop:ui:path:read:/admin/roles/new',
  },
  {
    pattern: '/admin/roles/:id/edit',
    permission: 'lop:ui:path:read:/admin/roles/:id/edit',
  },
  {
    pattern: '/admin/permissions',
    permission: 'lop:ui:path:read:/admin/permissions',
  },
  {
    pattern: '/admin/permissions/new',
    permission: 'lop:ui:path:read:/admin/permissions/new',
  },
  {
    pattern: '/admin/permissions/:id/edit',
    permission: 'lop:ui:path:read:/admin/permissions/:id/edit',
  },
  {
    pattern: '/reporting',
    permission: 'lop:ui:path:read:/reporting',
  },
  {
    pattern: '/reporting/manual-spend',
    permission: 'lop:ui:path:read:/reporting/manual-spend',
  },
]
